<template>
    <!-- <div class="absolute z-[999] bg-[#252526] w-[80vw] h-[100vh] top-0 left-[59%] translate-x-[-50%]"> -->
    <div class="w-[90%] mx-auto mt-[20px] z-[9999] relative h-[100vh]">
        <div class="text-white font-bold text-center mt-[20px] text-[21px]">Додавання конспекту до тренування на {{dateFormatted}}</div>
        
        <div v-if="useSummaries" class=" mt-10 mb-5 rounded-[10px] overflow-y-auto">
            <div class="flex justify-between items-center w-[94%] mb-[12px] text-white">
                <input 
                    v-model="searchQuery"
                    class="bg-transparent border border-[#8C8C8C] bg-opacity-20 rounded-[6px] px-3 py-2 w-[50%] outline-none text-sm"
                    placeholder="Пошук за назвою"
                    :disabled="summariesLoading"
                />
                <div class="flex items-center gap-2">
                    <button 
                        @click="prevPage" 
                        :disabled="page === 1 || summariesLoading" 
                        class="px-3 py-2 rounded-[6px] border border-[#8C8C8C] bg-[#474849] bg-opacity-20 disabled:opacity-50 text-sm"
                    >
                        Назад
                    </button>
                    <span class="text-sm">Стор. {{ page }}</span>
                    <button 
                        @click="nextPage" 
                        :disabled="!hasNextPage || summariesLoading" 
                        class="px-3 py-2 rounded-[6px] border border-[#8C8C8C] bg-[#474849] bg-opacity-20 disabled:opacity-50 text-sm"
                    >
                        Далі
                    </button>
                </div>
            </div>
            <div class="flex justify-end mb-[15px]">
                <div @click="$emit('close')" class="bg-[#BD9135] mr-[125px] flex justify-center items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                    <span>Назад</span>
                </div>
            </div>
            <table class="w-[94%] ">
                <thead class="text-white select-none">
                    <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                        <th class="px-3 py-2 w-[45%] text-start font-bold text-sm">Назва конспекту</th>
                        <th class="px-3 py-2 w-[15%] text-start font-bold text-sm">Напрям</th>
                        <th class="px-3 py-2 w-[15%] text-start font-bold text-sm">Час</th>
                        <th class="px-3 py-2 w-[10%] text-end font-bold text-sm">ID</th>
                        <th class="px-3 py-2 w-[10%] text-end font-bold text-sm">Додати</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="summariesLoading">
                        <td colspan="6" class="px-3 py-4 text-center text-white font-semibold">Завантаження...</td>
                    </tr>
                    <tr v-for="summary in summaries" :key="summary.summary_id" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <td class="px-3 py-2 w-[5%] text-center font-medium text-sm">
                            <div class="rounded-full border-[1px] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                <span>{{ summary.name?.[0] || 'К' }}</span>
                            </div>
                        </td>
                        <td class="px-3 py-2 w-[45%] text-start font-medium text-sm truncate">{{ summary.name }}</td>
                        <td class="px-3 py-2 w-[15%] text-start font-medium text-sm truncate">{{ summary.direction || '—' }}</td>
                        <td class="px-3 py-2 w-[15%] text-start font-medium text-sm">{{ summary.duration ? `${summary.duration} хв` : '—' }}</td>
                        <td class="px-3 py-2 w-[10%] text-end font-medium text-sm">#{{ summary.summary_id?.split('-')[0] || '' }}...</td>
                        <td class="px-3 py-2 w-[10%] text-end font-medium text-sm">
                            <button 
                                @click="$emit('addSummary', summary)"
                                class="py-1 rounded-[10px] text-sm font-medium text-[#BD9135] border border-[#BD9135] px-3"
                            >
                                Обрати
                            </button>
                        </td>
                    </tr>
                    <tr v-if="!summariesLoading && !summaries?.length">
                        <td colspan="6" class="px-3 py-4 text-center text-white font-semibold">Конспектів не знайдено</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-else-if="!isProgramToViewVisible" class=" mt-10 mb-5 rounded-[10px] overflow-y-auto">
            <div class="flex justify-end mb-[15px]">
                <div @click="$emit('close')" class="bg-[#BD9135] mr-[125px] flex justify-center items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                    <span>Назад</span>
                </div>
            </div>
            <table class="w-[94%] ">
                <thead class="text-white select-none">
                    <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                        <th class="px-3 py-2 w-[35%] text-start font-bold text-sm">Назва програми тренуваннь</th>
                        <th class="w-[5%]" ></th>
                        <th class="px-3 py-2 text-end w-[204px] relative font-bold text-sm">
                            <div class="cursor-pointer w-[178px] z-[-40] pr-[26px]">Редагувати</div>
                        </th>
                        <th class="px-3 w-[10%] py-2 text-end font-bold text-sm">ID програми</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="program in programs" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                        <td class="px-3 py-2 w-[5%] text-center font-medium text-sm">
                            <div class="rounded-full border-[1px] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                <span>{{ program.name[0] }}</span>
                            </div>
                        </td>
                        <td class="px-3 py-2 w-[35%] text-start font-medium text-sm">{{ program.name }}</td>
                        <td class="w-[5%]" ></td>
                        <td class="px-3 py-2 text-end w-[204px] relative font-medium text-sm">
                            <div class="cursor-pointer w-[178px] z-[-40] pr-[26px]">

                                <button 
                                    @click="setProgramToView(program)"
                                    class="py-1 rounded-[10px] text-sm font-medium"    
                                >
                                    <img 
                                        src="@/assets/icons/pen_icon.svg" 
                                        class="w-6 h-6"
                                    >
                                </button>

                            </div>
                        </td>
                        <td class="px-3 w-[10%] py-2 text-end font-medium text-sm">#{{program.id.split('-')[0]}}...</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <TrainingProgramView v-else @addSummary="summary => $emit('addSummary', summary)" :program="programToView" @close="isProgramToViewVisible = false" />
    </div>
</template>

<script>
    import { ref, onMounted, watch } from 'vue'
    import { getAllSummaries } from '@/services/apiRequests'
    import TrainingProgramView from './TrainingProgramView.vue'
    
    export default {
        name: 'add-summary-to-training-form',

        props: {
            date: {
                type: Date,
                required: true
            },
            programs: {
                type: Array,
                required: false,
                default: () => []
            },
            summaries: {
                type: Array,
                required: false,
                default: () => []
            },
            useSummaries: {
                type: Boolean,
                default: false
            }
        },

        setup(props, { emit }) {
            const dateFormatted = ref(props.date.split('-').reverse().join('.'))
            const allTrainingProgram = ref([])

            const screenWidth = window.innerWidth

            const programToView = ref({})
            const isProgramToViewVisible = ref(false)
            const setProgramToView = (program) => {
                programToView.value = program
                isProgramToViewVisible.value = true
            }

            const summaries = ref(props.summaries || [])
            const summariesLoading = ref(false)
            const page = ref(1)
            const perPage = 20
            const hasNextPage = ref(false)
            const searchQuery = ref('')

            const fetchSummaries = async () => {
                if (!props.useSummaries) return
                summariesLoading.value = true
                try {
                    const skip = perPage * (page.value - 1)
                    const res = await getAllSummaries(perPage, skip, {
                        ageCategory: 'all',
                        direction: 'all',
                        timeSort: 'none',
                    }, searchQuery.value)
                    summaries.value = res || []
                    hasNextPage.value = (res?.length || 0) === perPage
                } finally {
                    summariesLoading.value = false
                }
            }

            const nextPage = async () => {
                if (!hasNextPage.value || summariesLoading.value) return
                page.value += 1
                await fetchSummaries()
            }

            const prevPage = async () => {
                if (page.value === 1 || summariesLoading.value) return
                page.value -= 1
                await fetchSummaries()
            }

            watch(searchQuery, async () => {
                if (!props.useSummaries) return
                page.value = 1
                await fetchSummaries()
            })

            onMounted(async () => {
                if (props.useSummaries) {
                    await fetchSummaries()
                }
            })

            return {
                dateFormatted,
                allTrainingProgram,
                setProgramToView,
                programToView,
                isProgramToViewVisible,
                screenWidth,
                summaries,
                summariesLoading,
                page,
                hasNextPage,
                nextPage,
                prevPage,
                searchQuery,
                fetchSummaries
            }
        },

        components: {
            TrainingProgramView
        }
    }
</script>

<style lang="scss" scoped>

</style>